import {
  OsCostTab,
  PackageInformation,
  PriceMode,
  SwitchTabOS3P,
} from '@kizi/comparator-components';
import { IProduct, TriplePlayProductSupplier } from '@kizi/comparator-core';
import { TabDefinition } from '@kizi/shared-components';
import React, { MouseEventHandler } from 'react';

interface ITriplePlayTabs {
  data: IProduct;
  priceMode: PriceMode;
  setModalTab0: MouseEventHandler;
  setModalTab1: MouseEventHandler;
  setModalTab2: MouseEventHandler;
  setModalTab3: MouseEventHandler;
}

export function getTabs({ data }: ITriplePlayTabs): TabDefinition[] {
  return [
    {
      label: 'Pakket informatie',
      content: <PackageInformation data={data} />,
    },
    {
      label: 'Kosten',
      content: <OsCostTab data={data} />,
    },
    {
      label: 'Over je aanvraag',
      content: (
        <SwitchTabOS3P
          supplier={data.provider as unknown as TriplePlayProductSupplier}
          averageDeliveryTimeInDays={data?.averageDeliveryTimeInDays}
        />
      ),
    },
  ];
}
